
import { reactive, defineComponent } from 'vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import InlineFrame from '@/components/block/InlineFrame.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import TextLink from '@/components/elements/TextLink.vue'
import ModalHpcrTerms from '@/components/block/ModalHpcrTerms.vue'
import ModalHpcrPolicy from '@/components/block/ModalHpcrPolicy.vue'

export default defineComponent({
  name: 'HpcrRegister',

  components: {
    HeadingLv4,
    InlineFrame,
    TextBlock,
    TextLink,
    ModalHpcrTerms,
    ModalHpcrPolicy
  },
  props: {
    isRegisterByLine: {
      default: false
    },
    noIframe: {
      default: false
    }
  },
  setup() {
    const termsModal = reactive({
      isShow: false
    })
    const closeTermsModal = () => (termsModal.isShow = false)
    const openTermsModal = () => (termsModal.isShow = true)
    const policyModal = reactive({
      isShow: false
    })
    const closePolicyModal = () => (policyModal.isShow = false)
    const openPolicyModal = () => (policyModal.isShow = true)

    return {
      termsModal,
      closeTermsModal,
      openTermsModal,
      policyModal,
      closePolicyModal,
      openPolicyModal
    }
  }
})
